<chr-modal *transloco="let t" size="m" [closable]="true" (chr-modal-close)="close()">
  <chr-modal-header
    [title]="
      currentDownloadingFiles() === 0
        ? t('COMMON.FILE_MANAGER.DIALOG.TITLE_FINISHED')
        : t('COMMON.FILE_MANAGER.DIALOG.TITLE', { counts: currentDownloadingFiles() })
    "
  />

  <chr-modal-body>
    @if (hasErrorDuringDownloadingOccurred()) {
      <chr-validation-message [content]="t('COMMON.FILE_MANAGER.DOWNLOADING_ERROR')" [error]="true" />
    }

    <section class="collection-table">
      <table>
        <thead>
          <tr>
            <th class="file-name">
              <ciphr-table-column-header>{{ t("COMMON.FILE_MANAGER.LABELS.FILE") }}</ciphr-table-column-header>
            </th>
            <th>
              <ciphr-table-column-header>{{ t("COMMON.FILE_MANAGER.LABELS.STATUS") }}</ciphr-table-column-header>
            </th>
            <th class="actions-column">
              <ciphr-table-column-header>{{ t("COMMON.FILE_MANAGER.LABELS.ACTION") }}</ciphr-table-column-header>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (file of files(); track file.id) {
            <tr>
              <td class="file-name">{{ file.name }}</td>
              <td>
                @if (file.status === "pending") {
                  <chr-spinner size="s"></chr-spinner>
                }
                @if (file.status === "completed") {
                  <chr-icon class="completed" name="check-circle" size="s" />
                }
                @if (file.status === "failed") {
                  <chr-icon class="failed" name="exclamation-circle" size="s" />
                }
              </td>
              <td class="actions-column">
                <chr-button
                  [label]="t('COMMON.FILE_MANAGER.ACTIONS.CANCEL')"
                  [disabled]="file.status !== 'pending'"
                  palette="neutral"
                  variant="tertiary"
                  size="s"
                  (chr-action)="cancelFileDownloading(file)"
                />
              </td>
            </tr>
          }
        </tbody>
      </table>
    </section>
  </chr-modal-body>
  <chr-modal-footer>
    <chr-button (chr-action)="close()" [label]="t('COMMON.FILE_MANAGER.ACTIONS.CLOSE')" />
  </chr-modal-footer>
</chr-modal>
